import React, {useMemo} from 'react';
import {BaseFlagProps} from './types';

const BaseFlag: React.FC<BaseFlagProps> = ({uri, width}) => {
  const style = useMemo(
    () => ({
      width,
      height: width,
    }),
    [width],
  );

  return <img src={uri} style={style} />;
};

export {BaseFlag};
